import ZonoFiSmallLogo from './svgs/zonofi_small_logo.svg';
import ZonoFiLogo from './svgs/zono_login.svg';
import ZonoFieldCollection from './svgs/zono_filed_collection_login.svg';
import ZonoFieldCollectionOtpLogo from './svgs/zono_filed_collection_otp_.svg';
import Tick from './svgs/tick.svg';
import GoaTripWeb from './svgs/goatripweb.svg';
import CreditCard from './svgs/credit_card.svg';
import Internet from './svgs/internet.svg';
import OTPLock from './svgs/otp_lock.svg';
import UpiIcon from './svgs/upi-icon.svg';
import UserIcon from './svgs/user.svg';
import Group96 from './svgs/Group96.svg';
import GetStarted from './svgs/getStarted.svg';
import SplashScreenImage from './svgs/SplashscreenImage.svg';
import SplashScreenNewImage from './svgs/SplashscreenImage1.svg';
import WalletIcon from './svgs/wallet-icon.svg';
import BankAccountIcon from './svgs/bank-account.svg';
import UserProfileIcon from './svgs/user-profile-icon.svg';
import ZoTokLogo from './svgs/ZoTokLogo.svg';
import DiscountIcon from './svgs/discount_icon.svg';
import LogOutIcon from './svgs/power-off-logout-icon.svg';
import UserReceivingZCoins from './svgs/user-receiving-zcoins.svg';
import ZonoCoin from './svgs/ZonoCoin.svg';
import DebitedArrowTransaction from './svgs/debited_arrow_transaction.svg';
import CreditedArrowTransaction from './svgs/credited_arrow_transaction.svg';
import ErrorSVG from './svgs/error.svg';
import ErrorScreenImage from './svgs/error-image.svg';
import Share from './svgs/share.svg';
import Offer1 from './pngs/offer1.png';
import Offer2 from './pngs/offer2.png';
import Offer3 from './pngs/offer3.png';
import Offer4 from './pngs/offer4.png';
import Gpay from './pngs/Gpay_icon.png';
import Kyc from './pngs/kycImage.png';
import SubmittedIcon from './pngs/Submitted_icon.png';
import PinkImage from './pngs/J-7120 - Pink_image.png';
import RosePinkImage from './pngs/rosepink_image.png';
import CamelImage from './pngs/camel_image.png';
import SaheliGhera1 from './pngs/Saheli_Ghera1.jpeg';
import SaheliGhera2 from './pngs/Saheli_Ghera2.jpeg';
import TruptiFeedinggheraGrey from './pngs/Trupti_FeedinggheraGrey.jpeg';
import TruptiFeedinggheraPurple from './pngs/Trupti_FeedinggheraPurple.jpeg';
import TruptiFeedinggheraRed from './pngs/Trupti_FeedinggheraRed.jpeg';
import UserLogin from './svgs/login_user.svg';
import ZCoinBackground from './svgs/Zcoins.svg';
import Promo from './svgs/promo.svg';
import OfferCard from './svgs/offer1.svg';
import PaytmLogo from './svgs/paytm.svg';
import PhonePeLogo from './svgs/phone_pe.svg';
import GooglePay from './svgs/google_pay.svg';
import BhimUpi from './svgs/bhim_upi.svg';
import CircularTick from './svgs/tick-circle.svg';
import QRCode from './svgs/qrcode.svg';
import SbiLogo from './svgs/sbilogo.svg';
import CheckIn from './svgs/check-in.svg';
import LogOut from './svgs/log-out.svg';
import ZonoSellerLogo from './svgs/zono_seller_logo.svg';
import Wallet from './svgs/wallet.svg';
import ZonoLogoLatest from './svgs/ZonoLogo.svg';
import ZonoLogoWithTitle from './svgs/ZonoLogoWithTitle.svg';
import ShareLedger from './svgs/share_ledger.svg';
import SharePayment from './svgs/payment-link.svg';
import User from './svgs/user-icon.svg';
import Shop from './svgs/shop.svg';
import Verified from './svgs/verified.svg';
import EditIcon from './svgs/edit.svg';
import DoubleTick from './svgs/double_tick.svg';
import Plus from './svgs/plus.svg';
import Replace from './svgs/replace.svg';
import DownloadIcon from './svgs/download.svg';
import PlusIcon from './svgs/plus_icon.svg';
import PlusIconWhite from './svgs/plus_icon_white.svg';
import MinusIcon from './svgs/minus_icon.svg';
import MinusIconWhite from './svgs/minus_icon_white.svg';
import SearchIconOrder from './svgs/search_icon_order.svg';
import ErrorIcon from './svgs/icons8-error.svg';
import DiscountIconFindProduct from './svgs/discount_sticker_findproduct.svg';
import InvoiceFileIcon from './svgs/invoice_file_icon.svg';
import DownloadInvoiceIcon from './svgs/download_icon.svg';
import SearchIcon from './svgs/searchicon_order.svg';
import CartIconOrder from './svgs/cart_icon_order.svg';
import RightArrow from './svgs/right-arrow.svg';
import RightArrowBlue from './svgs/right-arrow-blue.svg';
import LeftArrowWhite from './svgs/left_arrow_white.svg';
import OrderSuccess from './svgs/ordersuccess_icon.svg';
import ZotokLogoGreen from './svgs/ZoTok_Logo_Green.svg';
import InfoIcon from './svgs/info_icon.svg';
import DeleteIcon from './svgs/delete_icon.svg';
import OppsIcon from './svgs/opps_icon.svg';
import ZotokNewLogo from './svgs/ZoTok_Logo.svg';
// import DefaultProduct from './svgs/default-product.svg';
import DefaultProduct from './svgs/default-product-1.svg';
import XCircle from './svgs/x-circle.svg';
import { ReactComponent as XCircleComponent } from './svgs/x-circle.svg';
import SearchBlack from './svgs/search-black.svg';
import LeftArrowBlack from './svgs/left-arrow-black.svg';
import PlusPrimaryCyan from './svgs/plus_primary_cyan.svg';
import MinusPrimaryCyan from './svgs/minus_primary_cyan.svg';
import Camera from './svgs/camera.svg';
import Cart from './svgs/cart.svg';
import CartSmall from './svgs/cart-small.svg';
import Search from './svgs/search.svg';
import CameraBlue from './svgs/camera_cyan.svg';
import DeleteRed from './svgs/delete.svg';
import ImageUploadCharacter from './svgs/image-upload-character.svg';
import ImageScanActive from './svgs/image-scan-active.svg';
import ImageScanInActive from './svgs/image-scan-inactive.svg';
import ImageAddActive from './svgs/image-add-active.svg';
import ImageAddInactive from './svgs/image-add-inactive.svg';
import PlusIconBlue from './svgs/add-blue.svg';
import CartBox from './svgs/cart-box.svg';
import NotesIcon from './svgs/notes.svg';
import BellIcon from './svgs/bellImage.svg';
import greenTick from './svgs/greenTick.svg';
import BlueInfo from './svgs/blueInfo.svg';
import ActiveIcon from './svgs/activeTick.svg';
import InactiveIcon from './svgs/InactiveTick.svg';
import SuccessfulKycMsgIcon from './svgs/successfulKycIcon.svg';
import WarningRed from './svgs/warning-red.svg';
import ErrorScreenImageV2 from './svgs/error-screen-v2.svg';
import Restricted from './svgs/restricted.svg';
import CheckGreenIcon from './svgs/tick_done_check.svg';
import ListView from './svgs/list_view.svg';
import GridView from './svgs/grid_view.svg';
import ErrorIconRed from './svgs/error-icon-red.svg';
import ChantIconBlack from './svgs/chat-black.svg';
import CartIconWhite from './svgs/cart-icon-white.svg';
import ViewToggleDisabled from './svgs/title-view-disabled.svg';
import EmptySearch from './svgs/empty-search.svg';
import EmptyCart from './svgs/empty-cart.svg';
import CloseIconBlack from './svgs/close-icon-black.svg';
import VideoPlayIcon from './svgs/video-play.svg';
import ESBG from './svgs/es-bg.svg';
import ESBG1 from './pngs/es_bg.png';
import Whatsapp3D from './pngs/whatsapp3d.png';
import CalendarIcon from './svgs/calendarIcon.svg';
import SuccessTick from './svgs/success-tick.svg';
import WhatsAppIconWhite from './svgs/whatsapp-icon-white.svg';
import AddedToCart from './svgs/added-to-cart.svg';
import { ReactComponent as RightArrowComp } from './svgs/right-arrow.svg';
import { ReactComponent as EditIconComp } from './svgs/edit-icon.svg';
import OtherDetailsIcon from './svgs/other-details-icon.svg';
import Merchandising from './svgs/merchandising.svg';
import FolderIcon from './svgs/folder-icon.svg';
import CheckBoxTick from './svgs/check-box-tick.svg';
import CheckBoxUnTick from './svgs/check-box-un-tick.svg';
import ShareIcon from './svgs/share-icon.svg';
import MasonryGridIcon from './svgs/masonry-grid.svg';
import CarouselViewIcon from './svgs/carousel-view.svg';
import BackIcon from './svgs/back-icon.svg';
import CloseIcon from './svgs/close-icon.svg';
import ForwardIcon from './svgs/forward-icon.svg';
import ProductIcon from './svgs/product-img.svg';
import SkuTag from './svgs/sku-tag.svg';
import PriceTag from './svgs/price-tag.svg';
import linkIcon from './svgs/share-link.svg';
import CanvasShape from './svgs/canvas-shape.svg';
import CanvasShapeActive from './svgs/canvas-shape-active.svg';
import CopyIconGray from './svgs/copy.svg';
import BankIcon from './svgs/bank-icon.svg';
import InvoicePartiallyPaid from './svgs/invoice-partially-paid.svg';
import InvoicePaid from './svgs/invoice-paid.svg';
import CatalogueIcon from './svgs/catalogue-icon.svg';
import InvoiceIconOutline from './svgs/invoice-outline.svg';
import LedgerOutline from './svgs/ledger-outline.svg';
import PhoneIcon from './svgs/phone-icon.svg';
import PhoneOutlineBlack from './svgs/phone-outline-black.svg';
import EnvelopIcon from './svgs/envelope-icon.svg';
import EnvelopOutlineBlack from './svgs/envelope-outline-black.svg';
import LedgerOutlineBlack from './svgs/ledger-outline-black.svg';
import InvoiceIconOutlineBlack from './svgs/invoice-outline-black.svg';
import CatalogueOutlineBlack from './svgs/catalogue-outline-black.svg';
import PaymentConfirmed from './svgs/payment-confirm.svg';
import Payment from './svgs/payment.svg';
import PaymentOutlineBlack from './svgs/payment-outline-black.svg';
import PaymentEmptyState from './pngs/payments-empty-state.png';
import InvoiceEmptyState from './pngs/invoice-empty-state.png';
import EyeIcon from './svgs/eye-icon.svg';
import CalenderIconNew from './svgs/calender-icon.svg';
import CalenderIconWithNew from './svgs/calendar-white.svg';
import FiltersIcon from './svgs/filters-icon.svg';
import EmptyLedger from './pngs/empty-ledger.png';
import SquareCheckboxUnchecked from './svgs/square-checkbox-unchecked.svg';
import SquareCheckboxBlack from './svgs/square-checkbox-black.svg';
import SquareCheckboxDisabled from './svgs/square-checkbox-disabled.svg';
import AddIconBlue from './svgs/add-icon-blue.svg';
import MinuxIconBlue from './svgs/minus-icon-blue.svg';
import InfoIconBlack from './svgs/InfoIcon-black.svg';
import SchemeFreeIcon from './svgs/scheme_free.svg';
import SchemePercentIcon from './pngs/scheme_percent.png';
import SchemeProductsIcon from './pngs/scheme_products.png';
import SchemeDivisionIcon from './pngs/scheme_division.png';
import InfoWhiteIcon from './svgs/info_white.svg';
import InfoLightBlue from './svgs/Info-light-blue.svg';
import BackArrow from './svgs/back_arrow.svg';
import MerchantIcon from './svgs/merchant_icon.svg';
import CopyLightGrayIcon from './svgs/copy_light_gray.svg';
import DocGreenIcon from './svgs/doc_green.svg';
import CheckHollowIcon from './svgs/check_hollow.svg';
import AWaiting from './svgs/awaiting.svg';

export const SVGS = {
  ZonoFiSmallLogo: ZonoFiSmallLogo,
  ZonoFieldCollectionLogo: ZonoFieldCollection,
  ZonoFiLogo: ZonoFiLogo,
  ZonoFieldCollectionOtpLogo: ZonoFieldCollectionOtpLogo,
  Tick: Tick,
  GoaTripWeb: GoaTripWeb,
  CreditCard: CreditCard,
  Internet: Internet,
  OTPLock: OTPLock,
  UpiIcon: UpiIcon,
  UserIcon: UserIcon,
  Group96: Group96,
  GetStarted: GetStarted,
  SplashScreenImage: SplashScreenImage,
  SplashScreenNewImage: SplashScreenNewImage,
  WalletIcon: WalletIcon,
  BankAccountIcon: BankAccountIcon,
  UserProfileIcon: UserProfileIcon,
  ZoTokLogo: ZoTokLogo,
  DiscountIcon: DiscountIcon,
  LogOutIcon: LogOutIcon,
  UserReceivingZCoins: UserReceivingZCoins,
  ZonoCoin: ZonoCoin,
  CreditedArrowTransaction: CreditedArrowTransaction,
  DebitedArrowTransaction: DebitedArrowTransaction,
  ErrorSVG: ErrorSVG,
  EmptySearch: EmptySearch,
  ErrorScreenImage: ErrorScreenImage,
  EmptyCart: EmptyCart,
  Share: Share,
  UserLogin: UserLogin,
  Promo: Promo,
  ZCoinBackground: ZCoinBackground,
  OfferCard: OfferCard,
  PaytmLogo: PaytmLogo,
  BhimUpi: BhimUpi,
  GooglePay: GooglePay,
  PhonePeLogo: PhonePeLogo,
  CircularTick: CircularTick,
  QRCode: QRCode,
  SbiLogo: SbiLogo,
  CheckIn: CheckIn,
  LogOut: LogOut,
  ZonoSellerLogo: ZonoSellerLogo,
  Wallet: Wallet,
  ZonoLogoLatest: ZonoLogoLatest,
  ZonoLogoWithTitle: ZonoLogoWithTitle,
  ShareLedger: ShareLedger,
  SharePayment: SharePayment,
  User,
  Shop,
  Verified,
  EditIcon,
  DoubleTick,
  Plus,
  PlusIcon,
  PlusIconWhite,
  MinusIcon,
  MinusIconWhite,
  SearchIconOrder,
  Replace,
  DownloadIcon,
  ErrorIcon,
  DiscountIconFindProduct,
  InvoiceFileIcon,
  Merchandising,
  DownloadInvoiceIcon,
  SearchIcon,
  CartIconOrder,
  RightArrow,
  RightArrowBlue,
  OrderSuccess,
  LeftArrowWhite,
  ZotokLogoGreen,
  InfoIcon,
  DeleteIcon,
  OppsIcon,
  ZotokNewLogo,
  DefaultProduct,
  XCircle,
  XCircleComponent,
  SearchBlack,
  LeftArrowBlack,
  PlusPrimaryCyan,
  MinusPrimaryCyan,
  Camera,
  Cart,
  CartSmall,
  ListView: ListView,
  GridView: GridView,
  Search,
  CameraBlue,
  DeleteRed,
  ImageScanActive,
  ImageScanInActive,
  ImageAddActive,
  ImageAddInactive,
  ImageUploadCharacter,
  PlusIconBlue,
  CartBox,
  NotesIcon,
  BellIcon,
  greenTick,
  BlueInfo,
  InactiveIcon,
  ActiveIcon,
  SuccessfulKycMsgIcon,
  WarningRed,
  ErrorScreenImageV2,
  Restricted,
  CheckGreenIcon,
  ErrorIconRed,
  ChantIconBlack,
  CartIconWhite,
  ViewToggleDisabled,
  CloseIconBlack,
  VideoPlayIcon,
  ESBG,
  CalendarIcon,
  SuccessTick,
  WhatsAppIconWhite,
  AddedToCart,
  RightArrowComp,
  EditIconComp,
  OtherDetailsIcon,
  FolderIcon,
  CheckBoxTick,
  CheckBoxUnTick,
  ShareIcon,
  MasonryGridIcon,
  CarouselViewIcon,
  CloseIcon,
  BackIcon,
  ForwardIcon,
  ProductIcon,
  SkuTag,
  PriceTag,
  linkIcon,
  CanvasShape,
  CanvasShapeActive,
  CopyIconGray,
  BankIcon,
  InvoicePartiallyPaid,
  InvoicePaid,
  CatalogueIcon,
  InvoiceIconOutline,
  LedgerOutline,
  PhoneIcon,
  EnvelopIcon,
  PaymentConfirmed,
  Payment,
  LedgerOutlineBlack,
  InvoiceIconOutlineBlack,
  CatalogueOutlineBlack,
  PhoneOutlineBlack,
  EnvelopOutlineBlack,
  PaymentOutlineBlack,
  PaymentEmptyState,
  InvoiceEmptyState,
  EyeIcon,
  CalenderIconNew,
  FiltersIcon,
  CalenderIconWithNew,
  SquareCheckboxBlack,
  SquareCheckboxDisabled,
  SquareCheckboxUnchecked,
  AddIconBlue,
  MinuxIconBlue,
  InfoIconBlack,
  SchemeFreeIcon,
  SchemePercentIcon,
  SchemeProductsIcon,
  SchemeDivisionIcon,
  InfoWhiteIcon,
  InfoLightBlue,
  BackArrow,
  MerchantIcon,
  CopyLightGrayIcon,
  DocGreenIcon,
  CheckHollowIcon,
  AWaiting,
};

export const PNGS = {
  Offer1: Offer1,
  Offer2: Offer2,
  Offer3: Offer3,
  Offer4: Offer4,
  Gpay: Gpay,
  Kyc: Kyc,
  ESBG1: ESBG1,
  Whatsapp3D: Whatsapp3D,
  PinkImage,
  RosePinkImage,
  SubmittedIcon,
  CamelImage,
  SaheliGhera1,
  SaheliGhera2,
  TruptiFeedinggheraGrey,
  TruptiFeedinggheraPurple,
  TruptiFeedinggheraRed,
  EmptyLedger,
  SchemeFreeIcon,
  SchemePercentIcon,
  SchemeProductsIcon,
  SchemeDivisionIcon,
};
